import { render, staticRenderFns } from "./CallReport115.vue?vue&type=template&id=95e2aab0&scoped=true&"
import script from "./CallReport115.vue?vue&type=script&lang=js&"
export * from "./CallReport115.vue?vue&type=script&lang=js&"
import style0 from "./CallReport115.vue?vue&type=style&index=0&id=95e2aab0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e2aab0",
  null
  
)

export default component.exports